import React from "react";

import { ExistingNoteFields } from "./ExistingNoteFields";
import NoteFormOptions from "./NoteFormOptions";

export function NoteHeader({
  note,
  refetchNote,
  control,
  isTemplate,
  isSuperSOAP,
  isScribeEdit,
  onSaveAsDraft,
  onSubmitNote,
}) {
  if (isTemplate) {
    return (
      <>
        <div className="flex-1 flex flex-row items-center justify-end">
          <div className="justify-self-end">
            <NoteFormOptions note={note} />
          </div>
        </div>
      </>
    );
  }

  return (
    <ExistingNoteFields
      note={note}
      refetchNote={refetchNote}
      control={control}
      isSuperSOAP={isSuperSOAP}
      isScribeEdit={isScribeEdit}
      onSaveAsDraft={onSaveAsDraft}
      onSubmitNote={onSubmitNote}
    />
  );
}
